import localeAntd from 'antd/es/locale/en_US'

const messages = {
  'topBar.issuesHistory': 'Issues History',
  'topBar.projectManagement': 'Project Management',
  'topBar.typeToSearch': 'Search...',
  'topBar.findPages': 'Find pages...',
  'topBar.actions': 'Actions',
  'topBar.status': 'Status',
  'topBar.profileMenu.hello': 'Hello',
  'topBar.profileMenu.billingPlan': 'Billing Plan',
  'topBar.profileMenu.role': 'Role',
  'topBar.profileMenu.email': 'Email',
  'topBar.profileMenu.phone': 'Phone',
  'topBar.profileMenu.editProfile': 'Edit Profile',
  'topBar.profileMenu.logout': 'Logout',
  'topBar.mobidoc.description': 'Your personal assistant',

  // FILE DETAILS
  'fileDetails.download_btn': 'Download',
  'fileDetails.delete_btn': 'Delete',
  'fileDetails.edit_btn': 'Edit',
  'fileDetails.save_btn': 'Save',
  'fileDetails.previous_btn': 'Previous',
  'fileDetails.next_btn': 'Next',
  'fileDetails.page_of': 'of',

  'fileDetails.category_num': 'There is {categories} num of categories',
  'fileDetails.category_title': 'CATEGORIES :',
  'fileDetails.category_add': 'Add Category',
  'fileDetails.category_number': `{categories, plural, 
                                      =0 {No categories} 
                                      one {# category founded} 
                                      other {# categories founded}}`,

  'fileDetails.tag_title': 'LIST OF TAGS :',
  'fileDetails.tag_add': 'Add Tag',
  'fileDetails.tag_show_more': 'Show more...',
  'fileDetails.tag_hide': 'Hide...',

  // HOME
  'home.welcome': 'Welcome to ',
  'home.presentation': 'Your first - (and last) - personal assistant',
  'home.presentation.value':
    'Scan, store and automate all your administrative work and go paperless',
  'home.credentials.test': 'Credentials for testing purposes - ',
  'home.sign_up': 'Sign up',
  'home.sign_in.text': 'Sign in to your account',
  'home.sign_in': 'Sign in',
  'home.email': 'Email',
  'home.password': 'Password',
  'home.password.forgot': 'Forgot Password?',
  'home.sign_up.text': "Don't have an account?",

  // ON BOARDING
  'onBoarding.steps.title.mail': 'Confirmation',
  'onBoarding.steps.title.plan': 'Plan selection',
  'onBoarding.steps.title.payment': 'Payment',
  'onBoarding.steps.title.done': 'Done',
  'onBoarding.button.next': 'Next step',
  'onBoarding.button.previous': 'Previous step',
  'onBoarding.button.changeAbo': 'Change Pack',
  'onBoarding.button.firstStep': 'Continue',
  'onBoarding.button.done': 'Go to Dashboard',
  // MAIL STEP
  'onBoarding.mail.verification.thankYou': 'Thank you for your subscription',
  'onBoarding.mail.verification.guide':
    'We will now guide you to the onboarding process. This few steps will help you validate  your account and chose a subscription plan',
  'onBoarding.mail.verification.resendEmail': 'Resend',
  'onBoarding.mail.verification.validEmail': 'Email validated',
  'onBoarding.mail.verification.invalidEmail.message': 'Please Validate your email first',
  'onBoarding.mail.verification.invalidEmail.description': 'Check you inbox',

  // PLAN SELECTION
  'onBoarding.subscription.plan.pricing_table': 'Prices',
  'onBoarding.subscription.plan.select': 'Select',
  'onBoarding.subscription.plan.month': 'month',

  'onBoarding.subscription.freePlan.month': 'free',
  'onBoarding.subscription.freePlan.title': 'Discovery pack',
  'onBoarding.subscription.freePlan.options.trial': '90 free days',
  'onBoarding.subscription.freePlan.options.1': 'Try it free',
  'onBoarding.subscription.freePlan.options.2': 'Unlimited storage',
  'onBoarding.subscription.freePlan.options.3': 'Data stored in Switzerland',

  'onBoarding.subscription.monthlyPlan.title': 'Monthly pack',
  'onBoarding.subscription.monthlyPlan.options.trial': 'Included 90 free days',
  'onBoarding.subscription.monthlyPlan.options.1': 'Data stored in Switzerland',
  'onBoarding.subscription.monthlyPlan.options.2': 'Unlimited storage',
  'onBoarding.subscription.monthlyPlan.options.3': ' ',

  'onBoarding.subscription.yearlyPlan.title': 'Yearly pack',
  'onBoarding.subscription.yearlyPlan.options.trial': 'Save up to 2 months',
  'onBoarding.subscription.yearlyPlan.options.1': 'Included 90 free days',
  'onBoarding.subscription.yearlyPlan.options.2': 'Unlimited storage',
  'onBoarding.subscription.yearlyPlan.options.3': 'Data stored in Switzerland',
  // On Boarding Payment Step
  'onBoarding.payment.form.title': 'Payment Form',
  'onBoarding.payment.form.error.msg': 'Please check the Form',
  'onBoarding.payment.form.error.desc': 'Some errors have been detected',
  'onBoarding.payment.form.label.fullname': 'Full Name',
  'onBoarding.payment.form.error.fullname': 'Please enter your full name',
  'onBoarding.payment.form.label.street': 'Street',
  'onBoarding.payment.form.error.street': 'Please enter your street name',
  'onBoarding.payment.form.label.city': 'City',
  'onBoarding.payment.form.error.city': 'Please input your city',
  'onBoarding.payment.form.label.state': 'State',
  'onBoarding.payment.form.error.state': 'Please enter a valid state',
  'onBoarding.payment.form.label.postal': 'Postal code',
  'onBoarding.payment.form.error.postal': 'Please enter a valid postal code',
  'onBoarding.payment.form.label.card': 'Card info',

  // Stripe error code
  'onBoarding.payment.stripe.error.incomplete_number': 'The card number is incomplete.',
  'onBoarding.payment.stripe.error.incorrect_number': 'The card number is incorrect.',
  'onBoarding.payment.stripe.error.invalid_number':
    'The card number is not a valid credit card number.',
  'onBoarding.payment.stripe.error.invalid_expiry_month': "The card's expiration month is invalid.",
  'onBoarding.payment.stripe.error.invalid_expiry_year': "The card's expiration year is invalid.",
  'onBoarding.payment.stripe.error.invalid_cvc': "The card's security code is invalid.",
  'onBoarding.payment.stripe.error.expired_card': 'The card has expired.',
  'onBoarding.payment.stripe.error.incorrect_cvc': "The card's security code is incorrect.",
  'onBoarding.payment.stripe.error.incorrect_zip': "The card's zip code failed validation.",
  'onBoarding.payment.stripe.error.card_declined': 'The card was declined.',
  'onBoarding.payment.stripe.error.missing':
    'There is no card on a customer that is being charged.',
  'onBoarding.payment.stripe.error.processing_error':
    'An error occurred while processing the card.',
  'onBoarding.payment.stripe.error.rate_limit':
    "An error occurred due to requests hitting the API too quickly. Please let us know if you're consistently running into this error.",
}

export default {
  locale: 'en-US',
  localeAntd,
  messages,
}
